module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/61d5d7f79c765cada319270412c7e40f.svg";